import { Spin } from 'antd';
import React, { Fragment } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';

interface Props {
    loading?: boolean;
    data: any[];
    height?: number | string;
    onNext: () => void;
    hasMore: boolean;
    loader?: React.ReactNode;
    children: React.ReactNode; //table component antd
    infiniteScrollerStyle?: React.CSSProperties;
    style?: React.CSSProperties;
    scrollThreshold?: number;
    scrollableTarget?: string;
}

const InfiniteScroller = ({
    loading = false,
    data,
    height,
    onNext,
    hasMore,
    loader,
    children,
    infiniteScrollerStyle = {},
    style = {},
    scrollThreshold = 0.95,
    scrollableTarget,
}: Props) => {
    return (
        <div style={{ position: 'relative', ...style }}>
            <InfiniteScroll
                scrollableTarget={scrollableTarget}
                scrollThreshold={scrollThreshold}
                dataLength={data?.length || 0}
                next={onNext} //function which fetches data from api
                hasMore={hasMore} //depending on this value onNext will be called
                style={{ overflowX: 'hidden', overflowY: loading ? 'hidden' : 'auto', ...infiniteScrollerStyle }}
                height={height}
                loader={loader ? loader : <LoaderComponent loading={loading} />}
            >
                {children}
            </InfiniteScroll>
        </div>
    );
};

export default InfiniteScroller;

const LoaderComponent = ({ loading }: { loading: boolean }) => {
    return (
        <>
            {loading && (
                <Spin
                    style={{
                        alignItems: 'center',
                        zIndex: 10,
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translateX(-50%)',
                    }}
                />
            )}
        </>
    );
};

// SAMPLE USAGE OF THIS COMPONENT WITH ANTD TABLE

// const renderTable = () => {
//     return (
//         <Table
//             style={{ opacity: loading ? '0.3' : 1 }}
//             // loading={loading}
//             className=""
//             id="table-body"
//             //style={{ overflowX: 'hidden' }}
//             scroll={{ x: '100' }}
//             sticky
//             dataSource={data}
//             columns={columns}
//             pagination={false}
//         />
//     );
// };

// const onNext = () => {
//     setLoading(true);
//     setTimeout(() => {
//         setData([...data, ...dataa.slice(0, 2)]);
//         setLoading(false);
//     }, 1500);
// };

// const dataa = [
//     { name: 'vFHij', age: 25 },
//     { name: 'ASD', age: 21 },
//     { name: 'DFG', age: 21 },
//     { name: 'GHJ', age: 21 },
//     { name: 'HJK', age: 21 },
//     { name: 'FGH', age: 21 },
//     { name: 'ajSDFai', age: 21 },
//     { name: 'SDF', age: 21 },
//     { name: 'FGH', age: 21 },
//     { name: 'ajFGai', age: 21 },
// ];
// const columns: any = [
//     {
//         title: 'Name',
//         fixed: 'left',
//         dataIndex: 'name',
//         key: 'name',
//         render: (columnData: any) => <>{columnData}</>,
//     },
//     { title: 'Age', dataIndex: 'age', key: 'age', render: (columnData: any) => <>{columnData}</> },
// ];

// <InfiniteScrollerTable
// style={{ padding: 10 }}
// data={data}
// loading={loading}
// hasMore={data.length < 20}
// height={250}
// onNext={onNext}
// children={renderTable()}
// />
